import { IMenuItemData, MenuItemRecord, menuItemFromJSON } from "common/records/MenuItem";
import { v4 as uuid } from "uuid";
import { List, Record } from "immutable";

export const sectionFromJSON = (json: Partial<ISectionData>): SectionRecord => {
  const recordData: ISectionRecord = { ...(json as any) };

  if (!json.uuid) {
    recordData.uuid = uuid();
  }

  recordData.menuItems = List((json.menuItems || []).map((menuItem) => menuItemFromJSON(menuItem)));

  return new SectionRecord(recordData);
};

export interface ISectionData {
  uuid: string;
  class: string;
  label: string;
  renderedLabel: string;
  menuItems: IMenuItemData[];
}

export interface ISectionRecord {
  uuid: string;
  class: string;
  label: string;
  renderedLabel: string;
  menuItems: List<MenuItemRecord>;
}

export const defaultSectionProps: ISectionRecord = {
  uuid: uuid(),
  class: "",
  label: "",
  renderedLabel: "",
  menuItems: List(),
};

export class SectionRecord extends Record(defaultSectionProps) implements ISectionRecord {}
